import ajax from '@/libs/Ajax'

export default {

    querySysParaList(params) {
        return ajax.get('/aseapi/console/sysmgr/sysparamgr/listSysPara', {params: params})
    },

    saveSysPara(data) {
        return ajax.post('/aseapi/console/sysmgr/sysparamgr/saveSysPara', data)
    },
    updateSysPara(data) {
        return ajax.post('/aseapi/console/sysmgr/sysparamgr/updateSysPara', data)
    },
    delSysPara(params) {
        return ajax.post('/aseapi/console/sysmgr/sysparamgr/deleteSysPara', params)
    },
    getSysParas() {
        return ajax.get('/aseapi/console/sysmgr/sysparamgr/getSysParas')
    },
    saveSysParaSetting(data) {
        return ajax.post('/aseapi/console/sysmgr/sysparamgr/saveSysParaSetting', data)
    },

}